import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import Add from "@/components/management/search/Add";
import { sysDatasourceQueryList, sysDatasourceQueryId, sysDatasourceQueryDelete } from "@/api/management/search";
export default {
  name: "search",
  components: {
    Sift: Sift,
    Add: Add
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      siftData: [{
        type: "text",
        key: "name",
        label: "名称",
        placeholder: "",
        default: ""
      }],
      current: 1,
      size: 10,
      total: 0,
      list: [],
      deleteDialog: false,
      selectedRow: {}
    };
  },
  computed: {},
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.initPage();
    });
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    initPage: function initPage() {
      this.current = 1;
      this.getList();
    },
    changePage: function changePage(page) {
      this.current = page;
      this.getCaseList();
    },
    getList: function getList() {
      var _this2 = this;

      var searchData = this.$refs.needSift.getValue();
      sysDatasourceQueryList({
        current: this.current,
        size: this.size,
        keywords: searchData.name
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this2.list = data.data.records;
          _this2.total = data.data.total;
        } else {
          _this2.$message.error(data.msg);
        }
      });
    },
    add: function add() {
      this.$refs.addDialog.dialogOpen();
    },
    eidt: function eidt(row) {
      this.$refs.addDialog.dialogOpen(row);
    },
    deleteSearch: function deleteSearch(row) {
      this.selectedRow = row;
      this.deleteDialog = true;
    },
    deleteSubmit: function deleteSubmit() {
      var _this3 = this;

      sysDatasourceQueryDelete({
        ids: this.selectedRow.id
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this3.$message.success("删除成功");

          _this3.initPage();
        } else {
          _this3.$message.error(data.msg);
        }
      }).finally(function () {
        _this3.deleteDialog = false;
      });
    },
    goSearch: function goSearch(row) {
      var routeData = this.$router.resolve({
        name: "/search",
        query: {
          id: row.id
        }
      });
      window.open(routeData.href);
    }
  },
  watch: {},
  filters: {}
};